// extracted by mini-css-extract-plugin
export var hasHero = "HeroSection-module--hasHero--YYgRn";
export var headerSpacer = "HeroSection-module--headerSpacer--Bns+V";
export var hero = "HeroSection-module--hero--l-Bmn";
export var heroSection = "HeroSection-module--heroSection--rxgo0";
export var heroWrapper = "HeroSection-module--heroWrapper--vg0IM";
export var introCard = "HeroSection-module--introCard--6FYJ1";
export var introCardColumn = "HeroSection-module--introCardColumn--xcggh";